import { render, staticRenderFns } from "./LinkPromptModal.vue?vue&type=template&id=011db8b1&"
import script from "./LinkPromptModal.vue?vue&type=script&setup=true&lang=ts&"
export * from "./LinkPromptModal.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports